/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createChimeMeeting = /* GraphQL */ `
  query CreateChimeMeeting($title: String, $name: String, $region: String) {
    createChimeMeeting(title: $title, name: $name, region: $region) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const joinChimeMeeting = /* GraphQL */ `
  query JoinChimeMeeting($meetingId: String, $name: String) {
    joinChimeMeeting(meetingId: $meetingId, name: $name) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const endChimeMeeting = /* GraphQL */ `
  query EndChimeMeeting($meetingId: String) {
    endChimeMeeting(meetingId: $meetingId) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const startTranscription = /* GraphQL */ `
  query StartTranscription($meetingId: String) {
    startTranscription(meetingId: $meetingId) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const stopTranscription = /* GraphQL */ `
  query StopTranscription($meetingId: String) {
    stopTranscription(meetingId: $meetingId) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const saveTranscriptionS3 = /* GraphQL */ `
  query SaveTranscriptionS3(
    $meetingId: String
    $transcriptionData: [TranscriptionData]!
    $timestamp: Float
  ) {
    saveTranscriptionS3(
      meetingId: $meetingId
      transcriptionData: $transcriptionData
      timestamp: $timestamp
    ) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const getPresignedURL = /* GraphQL */ `
  query GetPresignedURL($bucketName: String, $keyName: String) {
    getPresignedURL(bucketName: $bucketName, keyName: $keyName) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const getAudioMessages = /* GraphQL */ `
  query GetAudioMessages {
    getAudioMessages {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const deleteAudioMessage = /* GraphQL */ `
  query DeleteAudioMessage($receiptHandle: String) {
    deleteAudioMessage(receiptHandle: $receiptHandle) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const sendAudioMessage = /* GraphQL */ `
  query SendAudioMessage($base64Audio: String, $meetingId: String) {
    sendAudioMessage(base64Audio: $base64Audio, meetingId: $meetingId) {
      statusCode
      headers
      body
      isBase64Encoded
      __typename
    }
  }
`;
export const getMeeting = /* GraphQL */ `
  query GetMeeting($title: String!) {
    getMeeting(title: $title) {
      meetingId
      title
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMeetings = /* GraphQL */ `
  query ListMeetings(
    $title: String
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMeetings(
      title: $title
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        meetingId
        title
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAttendee = /* GraphQL */ `
  query GetAttendee($attendeeId: String!) {
    getAttendee(attendeeId: $attendeeId) {
      attendeeId
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAttendees = /* GraphQL */ `
  query ListAttendees(
    $attendeeId: String
    $filter: ModelAttendeeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAttendees(
      attendeeId: $attendeeId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        attendeeId
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const meetingsByMeetingId = /* GraphQL */ `
  query MeetingsByMeetingId(
    $meetingId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    meetingsByMeetingId(
      meetingId: $meetingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        meetingId
        title
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
